import React from 'react';
import {useTranslation} from 'react-i18next';

export interface WithdrawReceiveProps {
  dailyLimit?: string | number;
  feeRate?: number; // 0.03 -> 3%
  withdrawTimes?: string | number;
  wagerRequirement?: string | number;
  note1?: string; // 可不传则使用i18n默认
  note2?: string;
}

const WithdrawReceive: React.FC<WithdrawReceiveProps> = props => {
  const {i18n} = useTranslation();
  const {dailyLimit, feeRate, withdrawTimes, wagerRequirement, note1, note2} =
    props;

  const percent =
    typeof feeRate === 'number' ? `${+(feeRate * 100).toFixed(2)}%` : '-';

  return (
    <div className="bg-[#fff] rounded-[0.5rem] p-3 mt-4 flex flex-col gap-2 mb-[0.4rem]">
      <div className="text-t1 text-sm font-medium">
        {i18n.t('withdraw-page.label.received') || 'Actual amount received:'}
      </div>

      <div className="flex flex-col gap-1 text-t3 text-sm font-medium">
        <div className="flex items-baseline gap-1 justify-between">
          <span className="text-t3">
            {i18n.t('withdraw-page.rules.dailyLimit') ||
              'Daily withdrawal limit:'}
          </span>
          <span className="text-[#0A0A0A] font-bold">{dailyLimit ?? '-'}</span>
        </div>
        <div className="flex items-baseline gap-1 justify-between">
          <span className="text-t3">
            {i18n.t('withdraw-page.rules.fees') || 'withdrawal fees:'}
          </span>
          <span className="text-[#0A0A0A] font-bold">{percent}</span>
        </div>
        <div className="flex items-baseline gap-1 justify-between">
          <span className="text-t3">
            {i18n.t('withdraw-page.rules.timesTitle') ||
              'Daily withdrawal times:'}
          </span>
          <span className="text-[#0A0A0A] font-bold">
            {withdrawTimes ?? '-'}
          </span>
        </div>
        <div className="flex items-baseline gap-1 justify-between">
          <span className="text-t3">
            {i18n.t('withdraw-page.rules.wager') || 'Wager Requirement:'}
          </span>
          <span className="text-[#0A0A0A] font-bold">
            {wagerRequirement ?? '-'}
          </span>
        </div>
      </div>

      <div className="h-[1px] bg-[#D8E0EA]" />

      <div className="text-t3 text-xs flex flex-col gap-2">
        <p>
          {note1 ||
            i18n.t('withdraw-page.rules.note1') ||
            'Note: withdraw may be delayed due to someBank issues. In this case, the withdrawn amount will be returned to your wallet. Thank you for your patience.'}
        </p>
        <p>
          {note2 ||
            i18n.t('withdraw-page.rules.note2') ||
            'We have found some money laundry behaviorsSo limits that recharge amount should be used for betting only. The commission and wininoa amount could be withdrawn immediately.'}
        </p>
      </div>
    </div>
  );
};

export default React.memo(WithdrawReceive);
